import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ErpService {
  private http = inject(HttpClient);

  url = environment.url.bffV3;

  getErpData(parameterset: string, regionId: number, hourly = 1): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.getErpFromBff(parameterset, regionId, hourly).subscribe(
        data => {
          resolve(data);
        },
        err => reject(err)
      );
    });
  }

  getErpFromBff(
    parameterset: string,
    regionId: number,
    hourly: number
  ): Observable<any> {
    const days = hourly === 1 ? 1 : 8;
    const fullUrl = `${this.url}/epp/regional/${regionId}/${days}/${hourly}`;
    const body = JSON.stringify(parameterset);
    return this.http
      .post(fullUrl, body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      })
      .pipe(
        map(data => {
          return data;
        })
      );
  }
}
